import React from 'react';

import Button from '@/components/Button/Button';

import CustomImage from '../CustomImage';

interface IPageEmptyStateProps {
  image: string;
  imageWidth?: number;
  imageHeight?: number;
  title: string;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  buttonClassName?: string;
  buttonIcon?: React.ReactNode;
  buttonVariant?: 'primary' | 'link' | 'outline';
  containerClassName?: string;
}

const PageEmptyState: React.FC<IPageEmptyStateProps> = ({
  image,
  imageWidth = 175,
  imageHeight = 175,
  title,
  description,
  buttonLabel,
  onButtonClick,
  buttonClassName,
  buttonIcon,
  buttonVariant = 'primary',
  containerClassName = '',
}) => (
  <div
    className={`flex flex-col gap-6 items-center justify-center text-center h-[75vh] ${containerClassName}`}
  >
    {image && (
      <CustomImage
        src={image}
        alt="Empty State"
        width={imageWidth}
        height={imageHeight}
      />
    )}
    <div>
      <h2 className="text-2xl font-semibold leading-8 tracking-[-0.24px] text-neutral-primary">
        {title}
      </h2>
      {description && (
        <p className="text-neutral-secondary mt-2 leading-6">{description}</p>
      )}
    </div>
    {buttonLabel && (
      <Button
        icon={buttonIcon}
        label={buttonLabel}
        onClick={onButtonClick}
        className={buttonClassName}
        variant={buttonVariant}
      />
    )}
  </div>
);

export default PageEmptyState;
